<template>
    <div class="search-wrap" v-if="is_show">
        <div class="search-input">
            <span class="ico">⌕</span>
            <input type="text" placeholder="Search" @input="input" @enter="search" ref="input" />
            <Close @click.native="is_show = false" />
        </div>
        <div class="inner">
            <header class="search-header">
                <div class="top">
                    <span>{{count}} results</span>
                    <router-link @click.native="is_show = false" to="/">Home</router-link>
                </div>
                <ul>
                    <li v-for="(list, index) in results" :key="list.key + '1_2' + index" :class="['type-' + list.key]"  v-if="list.items.length !== 0" class="search-item">
                        <span class="search-link" @click="scrollTo(index)">{{list.title}}</span>
                    </li>
                </ul>
            </header>

            <div class="search-box" ref="search">
                <Loading v-if="is_loading" class="static" />
                <div v-for="(list, index) in results" :key="list.key + '_' + index" :id="'js-search-list-' + index">
                    <dl :class="['type-' + list.key]" class="list-item" v-if="list.items.length !== 0">
                        <dt>{{list.title}}</dt>
                        <dd v-for="item in list.items" :key="item.ID" @click="is_show = false">
                            <router-link :to="list.slug + item.post_name">{{item.post_title}}</router-link>
                        </dd>
                    </dl>
               </div>
            </div>
        </div>

    </div>
</template>

<script>
// import '@/assets/svg/search.svg?sprite';

import { EventBus } from '@/events/bus.js';
import Close from '@/components/ui/Close.vue';
import Loading from '@/components/Loading.vue';
import debounce from 'lodash/debounce';

export default {
    name: 'site-search',

    data() {
        return {
            is_show: false,
            is_loading: false,
            count: 0,
            results: [],
        }
    },


    components: {
        Loading,
        Close,
    },


    methods: {
        scrollTo(index) {
            let offset = window.innerWidth/7.1;
            this.$smoothScroll({
                container: this.$refs.search,
                offset: ~offset,
                scrollTo: document.querySelector('#js-search-list-' + index),
                duration: 300,
            });
        },


        input: debounce(function () {
            this.search();
        }, 500),

        search() {
            let val = this.$refs.input.value;

            if (!this.is_loading && val !== '') {
                this.is_loading = true;
                this.results = [];
                this.count = 0;

                this.$ajax.get('/search/?key_word=' + val).then(res => {
                    this.is_loading = false;

                    for (const [key, items] of Object.entries(res.data)) {
                        let slug = '';
                        let title = '';

                        switch (key) {
                            case 'pages':
                                slug = '/';
                                title = 'Other';
                                break;
                            case 'festivals':
                                slug = '/festival/';
                                title = 'Festivals';
                                break;
                            case 'exhibitions':
                                slug = '/exhibition/';
                                title = 'Exhibitions';
                                break;
                            case 'events':
                                slug = '/event/';
                                title = 'Events';
                                break;
                            case 'objects':
                                slug = '/object/';
                                title = 'In Focus';
                                break;
                            case 'stories':
                                slug = '/stories/';
                                title = 'Stories';
                                break;
                            case 'press':
                                slug = '/press/';
                                title = 'Press';
                                break;
                            case 'peoples':
                                slug = '/people/';
                                title = 'People';
                                break;
                            case 'products':
                                slug = '/product/';
                                title = 'Shop';
                                break;
                        }

                        console.log({key, items})

                        this.results.push({
                            title: title,
                            key: key,
                            slug: slug,
                            items: items,
                        });

                        this.count =+ (items.length);
                    }
                });
            }
        },
    },

    mounted() {
        EventBus.$off('search.open');
        EventBus.$on('search.open', () => {
            this.is_show = true;

            setTimeout(() => {
                this.$refs.input.value = '';
                this.$refs.input.focus();
            }, 1);
        });

        EventBus.$off('search.close');
        EventBus.$on('search.close', () => {
            this.is_show = false;
        });

    },

}
</script>

<style lang="scss">
    .search-wrap {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: black;
        z-index: 99999999999;

        & > .inner {
            display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: 100%;
            height: 100%;
        }

        .search-input {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 var(--padding);
            background: var(--gray);
            height: 6.4rem;

            .ico {
                position: relative;
                display: block;
                font-size: var(--padding-x2);

                svg {
                    height: 100%;
                    width: 100%;
                    fill: black;
                }
            }

            input {
                flex: 1;
                // margin: 0 var(--padding);
                padding: 1rem var(--padding);
                box-sizing: border-box;
                background: none;
                border: none;
                color: white;
                font-size: var(--medium-size);
                line-height: 1.2;

                &::placeholder {
                    color: white;
                }
            }
        }

        .loading-wrap.static {
            padding: 12rem 0;

            .lds-spinner {
                margin: 0 auto;
                padding: var(--padding-x2);
            }
        }

        .loading-wrap.static .lds-spinner div:after {
            background: #fff;
        }

        .close {
            position: absolute;
            padding: 0;
            top: 0;
            right: var(--padding);
            cursor: pointer;
            font-size: var(--padding-x2);
        }


        .search-header {
            padding: var(--padding) 0;
            color: white;

            .top {
                display: flex;
                padding: 0 0 var(--padding) 0;

                a {
                    color: white;
                }

                span {
                    flex: 1;
                }
            }

            ul {
                display: flex;

                li {
                    padding-right: var(--padding);
                }

                span {
                    cursor: pointer;
                }
            }

        }

            .type-festivals {
                .search-link,
                dt,
                a:hover {
                    color: #FF00FF;
                }
            }


            .type-exhibitions {
                .search-link,
                dt,
                a:hover {
                    color: #FFC700;
                }
            }

            .type-events {
                .search-link,
                dt,
                a:hover {
                    color: #E1FF60;
                }
            }

            .type-stories {
                .search-link,
                dt,
                a:hover {
                    color: #A4B8FF;
                }
            }

            .type-objects {
                .search-link,
                dt,
                a:hover {
                    color: #00FF00;
                }
            }

            .type-products {
                .search-link,
                dt,
                a:hover {
                    color: #65C75E;
                }
            }

            .type-press {
                .search-link,
                dt,
                a:hover {
                    color: #7A8700;
                }
            }

            .type-peoples {
                .search-link,
                dt,
                a:hover {
                    color: #FFC700;
                }
            }

            .type-pages {
                .search-link,
                dt,
                a:hover {
                    color: #B4B9BA;
                }
            }

        .search-box {
            overflow: auto;

            a {
                color: white;
            }

            & > div:last-child {
                padding-bottom: 10rem;
            }
        }

        .list-item {
            padding: 0;
            display: flex;//#FFC700
            flex-wrap: wrap;
            line-height: 1.2;

            dt,
            dd {
                padding-right: var(--padding-50);
                font-size: var(--medium-size);
            }

            dd::after {
                content: ', ';
                color: white;
            }

            dd:last-child::after {
                display: none;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .search-wrap {
            .search-input {
                height: var(--padding-x3);
                .ico {
                    padding-left: var(--padding-x3);
                }
            }
            .search-header {
                ul {
                    display: block;
                    li {
                        display: inline-block;
                    }
                }
            }
            .close {
                right: var(--padding-50);
                left: unset;
            }
        }
    }


</style>
